import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useCallback, useState } from 'react';
import { Checkbox } from '@/components/ui/Form/Checkbox';
import { FormGroup } from '@/components/ui/Form/FormGroup';
import { CASE_PRICES, CASE_PRICES_VALUES, } from '@/utils/constants/pages/case/casePrice';
export const CasePriceFilter = (props) => {
    const { className = '', initialValues, onClick } = props;
    // 選択中の値
    const [selectedValues, changeSelectedValues] = useState(() => (initialValues || []).filter((value) => CASE_PRICES_VALUES.includes(value)));
    /**
     * チェック時の処理
     * @description チェックボックスのチェック状態を変更する
     */
    const onChange = useCallback((event) => {
        const value = parseInt(event.target.value, 10);
        changeSelectedValues((prev) => {
            const nextValue = prev.includes(value)
                ? prev.filter((v) => v !== value)
                : [...prev, value];
            onClick === null || onClick === void 0 ? void 0 : onClick(nextValue);
            return nextValue;
        });
    }, [onClick]);
    return (_jsx("ul", { children: _jsx("li", { children: _jsx(FormGroup, Object.assign({ className: className, row: true, space: 'wide' }, { children: CASE_PRICES.map((item) => (_jsx(Checkbox, { checked: selectedValues.includes(item.value), label: item.label, onChange: onChange, value: `${item.value}` }, `CasePriceFilter_${item.value}`))) })) }) }));
};
